import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/landing/Yodo1_logo.png'
import _imports_1 from '../../assets/goat-sponsor.png'
import _imports_2 from '../../assets/landing/1022px-Plarium_Logo.png'
import _imports_3 from '../../assets/game-gym-sponsor.png'
import _imports_4 from '../../assets/landing/Voodoo_Logo.svg.png'
import _imports_5 from '../../assets/phoenix-sponsor.png'


const _withScopeId = n => (_pushScopeId("data-v-100b1b79"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "p-d-flex sponsors-container"
}
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<img src=\"" + _imports_0 + "\" class=\"yodo\" draggable=\"false\" data-v-100b1b79><img src=\"" + _imports_1 + "\" class=\"goat\" draggable=\"false\" data-v-100b1b79><img src=\"" + _imports_2 + "\" class=\"white-shadow\" draggable=\"false\" data-v-100b1b79><img src=\"" + _imports_3 + "\" class=\"game-gym\" draggable=\"false\" data-v-100b1b79><img src=\"" + _imports_4 + "\" class=\"white-shadow\" draggable=\"false\" style=\"max-height:35px;\" data-v-100b1b79><img src=\"" + _imports_5 + "\" class=\"phoenix\" draggable=\"false\" data-v-100b1b79>", 6)
const _hoisted_9 = [
  _hoisted_3
]
const _hoisted_10 = {
  key: 1,
  class: "sponsors-padding"
}
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"p-d-flex p-jc-center p-ai-center gap-sponsors-2\" data-v-100b1b79><img src=\"" + _imports_0 + "\" draggable=\"false\" data-v-100b1b79><img src=\"" + _imports_1 + "\" class=\"goat\" draggable=\"false\" data-v-100b1b79><img src=\"" + _imports_2 + "\" class=\"white-shadow\" draggable=\"false\" data-v-100b1b79></div><div class=\"p-d-flex p-jc-center p-mt-4 gap-sponsors-2\" data-v-100b1b79><img src=\"" + _imports_3 + "\" class=\"game-gym\" draggable=\"false\" data-v-100b1b79><img src=\"" + _imports_4 + "\" class=\"white-shadow\" draggable=\"false\" data-v-100b1b79><img src=\"" + _imports_5 + "\" class=\"phoenix\" draggable=\"false\" data-v-100b1b79></div>", 2)
const _hoisted_13 = [
  _hoisted_11
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_9))
      : (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_13))
  ]))
}